var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntitySelect } from '../entities/entity-select';
import { useComponentProps } from '../context/component-props-context';
import { EntitySelectOptionSmall } from '../entities/entity-select-option';
var cls = classNames('form-field-entity-select');
export var FormFieldEntitySelectDefaultProps = {
  pageSize: 10
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "], ["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "])), theme.FONT('app'))
});
// -------- Components -------->
var My = {
  NAME: 'FormFieldEntitySelect',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(EntitySelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var FormFieldEntitySelect = function (props) {
  var componentProps = useComponentProps(My.NAME, FormFieldEntitySelectDefaultProps, props);
  var className = props.className,
    onChange = props.onChange,
    autoFocus = props.autoFocus,
    isMultiple = props.isMultiple,
    value = props.value,
    pageSize = props.pageSize,
    disabled = props.disabled,
    name = props.name,
    data = props.data,
    entityTypeName = props.entityTypeName;
  // TODO - Does react-select pass the event through?  
  var handleChange = function (option) {
    if (option) {
      onChange({
        value: option,
        mutationValue: option.value
      });
    } else {
      // the new value is empty (select has been cleared)
      onChange({
        value: '',
        mutationValue: ''
      });
    }
  };
  var handleMultipleChange = function (options) {
    if (options) {
      onChange({
        value: options,
        mutationValue: options.map(function (option) {
          return option.value;
        })
      });
    } else {
      // the new value is empty (select has been cleared)
      onChange({
        value: [],
        mutationValue: []
      });
    }
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Select, {
    size: "slim",
    menuPortalTarget: document.body,
    value: value,
    optionComponent: EntitySelectOptionSmall,
    showSearchIcon: false,
    items: data || [],
    isDisabled: disabled,
    entityTypeName: entityTypeName,
    name: name,
    autoFocus: autoFocus,
    isMulti: isMultiple,
    onChange: isMultiple ? handleMultipleChange : handleChange
  }));
};
FormFieldEntitySelect.cls = cls;
export var FormFieldEntitySelectMultiple = function (props) {
  return React.createElement(FormFieldEntitySelect, __assign({}, props, {
    isMultiple: true
  }));
};
FormFieldEntitySelectMultiple.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;